import React, { useEffect, useRef } from "react";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend
);
const LineChart = ({ chartData, labels, onToggle, originalData, hidden }) => {
  const chartRef = useRef(null);
  useEffect(() => {
    if (chartRef.current) {
      const chart = chartRef.current;

      // apply hidden flags to datasets on re-render
      chart.data.datasets.forEach((ds) => {
        if (ds.label === "Stock Market") ds.hidden = hidden.stock;
        if (ds.label === "Commodities") ds.hidden = hidden.commodities;
        if (ds.label === "Real Estate") ds.hidden = hidden.realEstate;
        if (ds.label === "Cryptocurrency") ds.hidden = hidden.crypto;
         if (ds.label === "Depletion") ds.hidden = hidden.depletion;
         if (ds.label === "Mortgage") ds.hidden = hidden.mortgage;
      });

      chart.data.datasets[6].data = chartData.map((d) => d.netWorth); // sync networth
      chart.update();
    }
  }, [chartData, hidden]); // rerun whenever hidden or data changes

  let dataObj = chartData;

  const chartData1 = {
    labels,
    datasets: [
      
      {
        label: "Real Estate",
        data: dataObj.map((d) => +d.realEstate),
        borderColor: "#fb8500",
        backgroundColor: "#fb8500",
        tension: 0,
      },
      {
        label: "Stock Market",
        data: dataObj.map((d) => +d.stockMarket),
        borderColor: "#00008B",
        backgroundColor: "#00008B",
        tension: 0,
      },
      {
        label: "Commodities",
        data: dataObj.map((d) => +d.commodities),
        borderColor: "#f72585",
        backgroundColor: "#f72585",
        tension: 0,
      },
      {
        label: "Cryptocurrency",
        data: dataObj.map((d) => +d.crypto),
        borderColor: "#4cc9f0",
        backgroundColor: "#4cc9f0",
        tension: 0,
      },
      {
        label: "Depletion",
        data: dataObj.map((d) => +d.depletion),
        borderColor: "#4cf080ff",
        backgroundColor: "#4cf080ff",
        tension: 0,
      },
      {
        label: "Mortgage",
        data: dataObj.map((d) => +d.mortgage),
        borderColor: "#000",
        backgroundColor: "#000",
        tension: 0,
      },
      {
        label: "Networth",
        data: dataObj.map((d) => +d.netWorth),
        borderColor: "green",
         borderWidth: 5,    
        backgroundColor: "green",
        tension: 0,
      },
    ],
  };

  const options = {
    plugins: {
       
      legend: {
        onClick: (e, legendItem, legend) => {
          // Prevent toggling if it's "Networth"

          const chart = legend.chart;
          const datasetIndex = legendItem.datasetIndex;
          const ds = chart.data.datasets[datasetIndex];
          ds.hidden = !ds.hidden;

    
          // always reset NetWorth to baseline first
          const networthDataset = [];
          // Keep original NetWorth values (includes stocks + commodities + other values)
          let net = originalData.map((d) => +d.netWorth);
          networthDataset.data = net;
         
          chart.data.datasets.forEach((ds) => {
            ds.data = ds.data.map((v) => Number(v)); // or Math.round(v) if integers
          });

          // subtract all hidden datasets
          chart.data.datasets.forEach((d, idx) => {
            if (d.hidden && d.label !== "Networth") {
              if (
                d.label == "Real Estate" ||
                d.label == "Stock Market" ||
                d.label == "Commodities" ||
                d.label == "Cryptocurrency"
              )
                for (let i = 0; i < net.length; i++) {
                  networthDataset.data[i] = networthDataset.data[i];
                  const valueToSubtract = d.data[i] || 0;

                  // do math first, then round
                  networthDataset.data[i] = Number(
                    networthDataset.data[i] - valueToSubtract
                  );
                }
            }
          });

          //  chart.update();
          onToggle(legendItem.text, networthDataset.data);
        },
        labels: {
          color: "#808080",
        },
      },
      datalabels: {
        color: "white",
        anchor: "end",
        align: "top",
        font: {
          weight: "bold",
        },
        display: false, // hide datalabels
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            const label = context.dataset.label || "";
            const value = context.parsed.y;
            return `${label}: $${value.toLocaleString()}`;
          },
        },
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
      },
      y: {
        beginAtZero: true,
        ticks: {
          callback: function (value) {
            return "$" + value.toLocaleString();
          },
        },
      },
    },
    layout: {
      padding: {
        top: 20,
        bottom: 20,
      },
    },
  };

  return (
    <div className="NetWorth">
      <div className="flex">
        <div className="bannerStyle col-12 mb-4 mt-2">Networth Projection</div>
      </div>
      <Line ref={chartRef} data={chartData1} options={options} />
    </div>
  );
};

export default LineChart;
